var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "defult",
            fn: function () {
              return [
                _vm.checkRoles(["terminal", "partner"])
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "状态:" } },
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function ($event) {
                                return _vm.toQuery()
                              },
                            },
                            model: {
                              value: _vm.listQuery.check_order,
                              callback: function ($$v) {
                                _vm.$set(_vm.listQuery, "check_order", $$v)
                              },
                              expression: "listQuery.check_order",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "全部", value: "-1" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "未创建订单", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "已创建订单", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "设备SN:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_goods_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_goods_sn", $$v)
                        },
                        expression: "form.search_goods_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { label: "用户ID:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.uid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "uid", $$v)
                        },
                        expression: "form.uid",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-down",
                    attrs: { label: "时间筛选:" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "开始",
                            "value-format": "timestamp",
                            "picker-options": _vm.beginOptions,
                          },
                          model: {
                            value: _vm.form.begin,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "begin", $$v)
                            },
                            expression: "form.begin",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-5 mr-5" }, [_vm._v("-")]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "结束",
                            "value-format": "timestamp",
                            "picker-options": _vm.endOptions,
                          },
                          model: {
                            value: _vm.form.end,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "end", $$v)
                            },
                            expression: "form.end",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", "native-type": "submit" } },
                      [
                        _vm._v("查询"),
                        _c("i", {
                          staticClass: "el-icon-search el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery(1)
                          },
                        },
                      },
                      [
                        _vm._v("重置"),
                        _c("i", {
                          staticClass: "el-icon-refresh el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content:
                            "选择开始时间和结束时间,点击查询后即可导出该时间段内的订单",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.outTab("list_table", _vm.xlsxName)
                              },
                            },
                          },
                          [
                            _vm._v("导出"),
                            _c("i", {
                              staticClass: "el-icon-male el-icon--right",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.checkRoles(["terminal", "partner"])
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  path: "/order/scanStat",
                                })
                              },
                            },
                          },
                          [_vm._v("数据统计")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "more",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-up",
                    attrs: { label: "用户ID:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.uid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "uid", $$v)
                        },
                        expression: "form.uid",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-up",
                    attrs: { label: "时间筛选:" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "开始",
                            "value-format": "timestamp",
                            "picker-options": _vm.beginOptions,
                          },
                          model: {
                            value: _vm.form.begin,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "begin", $$v)
                            },
                            expression: "form.begin",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-5 mr-5" }, [_vm._v("-")]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "结束",
                            "value-format": "timestamp",
                            "picker-options": _vm.endOptions,
                          },
                          model: {
                            value: _vm.form.end,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "end", $$v)
                            },
                            expression: "form.end",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "p-5" }, [
        _c(
          "div",
          { staticClass: "bg-white" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                ref: "list_table",
                staticClass: "ptd-5",
                attrs: {
                  id: "list_table",
                  data: _vm.list,
                  "element-loading-text": "Loading",
                  stripe: "",
                  "highlight-current-row": "",
                  "max-height": _vm.tableMaxH,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "扫码ID", width: "70" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.id) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "类型", width: "70" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.deviceKeyObj[scope.row.depend_type]) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "来源", width: "70" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                scope.row.mini_type == 1 ? "微信" : "支付宝"
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "用户ID", width: "70" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.uid) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "用户昵称", width: "140" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "flex align-center" },
                            [
                              _c("el-avatar", {
                                attrs: { size: 30, src: scope.row.avatar },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex1 pl-10" }, [
                                _vm._v(_vm._s(scope.row.nick_name || "--")),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "手机号码" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.checkRoles(
                                  _vm.config.system_other.have_role
                                )
                                  ? scope.row.mobile
                                  : _vm.dealPhone(scope.row.mobile)
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "商户", "min-width": "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.store_name || "--")),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "扫码次数" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.scan_num) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.checkRoles(["terminal", "partner"])
                  ? _c("el-table-column", {
                      attrs: { label: "使用次数" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.used_num) +
                                    "\n          "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        508497811
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "时间", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.parseTime(
                                  scope.row.add_date,
                                  "{y}-{m}-{d} {h}:{i}:{s}"
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "SN码", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              "设备：" + _vm._s(scope.row.goods_sn || "--")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "底座：" + _vm._s(scope.row.device_id || "--")
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.deviceState[scope.row.device_status] || "--"
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.checkRoles(["terminal", "partner"])
                  ? _c("el-table-column", {
                      attrs: { label: "操作", width: "180" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.order_id > 0
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                          plain: "",
                                          round: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getOrderDetail(
                                              scope.row.order_id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "订单详情（" +
                                            _vm._s(scope.row.order_id) +
                                            "）"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        173248294
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-center" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listQuery.page_num > 0,
                      expression: "listQuery.page_num > 0",
                    },
                  ],
                  attrs: {
                    page: _vm.listQuery.start,
                    limit: _vm.listQuery.limit,
                    "page-count": _vm.listQuery.page_num,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "start", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "limit", $event)
                    },
                    pagination: _vm.getList,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "订单详情", visible: _vm.detailDialog },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialog = $event
            },
          },
        },
        [
          _c(
            "el-timeline",
            _vm._l(_vm.order.operate_flow, function (item, index) {
              return _c(
                "el-timeline-item",
                {
                  key: index,
                  attrs: { placement: "top", timestamp: item.date },
                },
                [
                  _c("div", [
                    _vm._v(_vm._s(item.event) + " ---> " + _vm._s(item.result)),
                  ]),
                  _vm._v(" "),
                  item.reason
                    ? _c(
                        "div",
                        { staticClass: "mt-5" },
                        [
                          _c("el-link", { attrs: { type: "danger" } }, [
                            _vm._v(_vm._s(item.reason)),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }